import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded';
import { StyledNoteTip } from './index.style';

const SlideNoteTip = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <StyledNoteTip>
      <TipsAndUpdatesRoundedIcon className="note-tip-icon" />
      <span className="note-tip-text">
        <Trans i18nKey="slideNoteTip" components={{ b: <b /> }} />
        <button
          type="button"
          className="note-tip-link"
          onClick={() => setDismissed(true)}
        >
          {t('gotIt')}
        </button>
      </span>
    </StyledNoteTip>
  );
};

export default SlideNoteTip;
